/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import FilterConstants from '../../filter-constants';
import DeliyannisFriend from './deliyannis-friend/deliyannis-friend';
import FirstOrder from './first-order/first-order';
import Inductor from './inductor/inductor';
import MultipleFeedback from './multiple-feedback/multiple-feedback';
import SallenKey from './sallen-key/sallen-key';

export default class Implementation extends EmberObject {
  selectedImplementation;
  filter;
  preferredAlgorithm;

  @computed('selectedImplementation', 'filter', 'preferredAlgorithm') get instance() {
    var selectedImplementation = this.selectedImplementation;
    var filter = this.filter;
    var preferredAlgorithm = this.preferredAlgorithm;

    var result = null;
    var hash = { filter: filter, preferredAlgorithm: preferredAlgorithm };
    if (selectedImplementation === FilterConstants.implementationType.deliyannisFriend) {
      result = DeliyannisFriend.create(hash);
    } else if (selectedImplementation === FilterConstants.implementationType.firstOrder) {
      result = FirstOrder.create(hash);
    } else if (selectedImplementation === FilterConstants.implementationType.inductor) {
      result = Inductor.create(hash);
    } else if (selectedImplementation === FilterConstants.implementationType.multipleFeedback) {
      result = MultipleFeedback.create(hash);
    } else {
      result = SallenKey.create(hash);
    }

    return result;
  }

  @computed('instance.name') get name() {
    return this.instance.name;
  }
  @computed('instance.circuit') get circuit() {
    return this.instance.circuit;
  }

  getStepValues(idealStep, components, timeAxis) {
    return this.instance.getStepValues(idealStep, components, timeAxis);
  }

  createCircuit(stageFp, gain, stageQ, optimization, initialCapacitorValue) {
    return this.instance.createCircuit(stageFp, gain, stageQ, optimization, initialCapacitorValue);
  }

  getInterestingCircuits(commercialCircuit, toleranceInput) {
    return this.instance.getInterestingCircuits(commercialCircuit, toleranceInput);
  }

  getStageValuesFromCircuit(circuit) {
    return this.instance.getStageValuesFromCircuit(circuit);
  }

  createBigHugeCircuitGroup(circuit, toleranceInput) {
    return this.instance.createBigHugeCircuitGroup(circuit, toleranceInput);
  }
}
